// extracted by mini-css-extract-plugin
export default {"board":"Board_board__elPzM","board_row":"Board_board_row__u4PqK"};